import React from 'react';
import { Ghost } from 'lucide-react';
import { ghostPace } from '../game/ghost';

// v3.14 GHOST MODE HUD — compact widget that shows your previous best on this seed and how you're pacing.
// Renders NOTHING if there's no ghost for the current seed. Safe to drop anywhere.
export default function GhostHUD({ ghost, currentFloor, currentScore, className = '', testid = 'ghost-hud' }) {
  if (!ghost) return null;
  const { pace, delta } = ghostPace(ghost, currentFloor);
  const paceColor =
    pace === 'ahead'  ? '#39ff14' :
    pace === 'behind' ? '#ff2b2b' :
    pace === 'tied'   ? '#ffd700' : '#a0a0a0';
  const paceLabel =
    pace === 'ahead'  ? `AHEAD +${delta}` :
    pace === 'behind' ? `BEHIND -${delta}` :
    pace === 'tied'   ? 'ON PACE' : '';

  return (
    <div
      className={`ghost-hud ${className}`}
      data-testid={testid}
      data-pace={pace}
      style={{ borderColor: paceColor, boxShadow: `3px 3px 0 ${paceColor}` }}
    >
      <div className="ghost-hud-icon" style={{ color: paceColor }}>
        <Ghost size={16} />
      </div>
      <div className="ghost-hud-body">
        <div className="ghost-hud-title" style={{ color: paceColor }} data-testid={`${testid}-title`}>
          GHOST · YOUR BEST
        </div>
        <div className="ghost-hud-stats">
          <span data-testid={`${testid}-floor`}>FL <b>{ghost.floor}</b></span>
          <span className="ghost-hud-sep">·</span>
          <span data-testid={`${testid}-score`}>SCORE <b>{ghost.score}</b></span>
          {typeof currentScore === 'number' && (
            <>
              <span className="ghost-hud-sep">·</span>
              <span data-testid={`${testid}-current`}>YOU <b>{currentScore}</b></span>
            </>
          )}
        </div>
        {paceLabel && (
          <div className="ghost-hud-pace" style={{ color: paceColor }} data-testid={`${testid}-pace`}>
            {paceLabel}
          </div>
        )}
      </div>
    </div>
  );
}
